export const defaultPlanVestingId = (userRole, vestingSchedule) =>
  vestingSchedule.value === 'immediate' ? 1 : 2;
